import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/css/owl.carousel.min.css';
import './assets/css/flexnav.css';
import Cookies 	from 'universal-cookie';
import './assets/css/custom.css';
import './assets/css/developer.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import AppRoutes from "./routes/web";
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from "react-query";
const cookies 	=	new Cookies();
const language	=	cookies.get('preferred_language');
console.log("test123");
if (language === 'ar') {
	const link = document.createElement('link');
	link.rel = 'stylesheet';
	link.href = '/css/ar-custom.css';
	document.head.appendChild(link);
}


const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false, // default: true
			retryDelay: 1000,
		},
	}
});
//React.StrictMode
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<QueryClientProvider client={queryClient}>
		<ToastContainer />
		<AppRoutes />
	</QueryClientProvider>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
